import { SystemEntityActionProps } from '../../models/system-entity-action-props.model';

export function systemEntityStateId(props: SystemEntityActionProps): string {
    return `type${props.entityType}Id${props.entityId}`;
}
